import moment from "moment"
export function formatDate(value) {
  if (value) {
    return moment.utc(String(value)).format("DD/MM/YYYY")
  }
  return "No Date Available"
}
export function formatDateTime(value) {
  if (value) {
    return moment.utc(String(value)).format("DD/MM/YYYY HH:mm:ss") + " CET"
  }
  return "No Date Available"
}

//new function for the homepage content - Kapil
export function formatReadbleDate(value) {
  if (value) {
    return moment.utc(String(value)).format("DD MMMM YYYY")
  }
  return "No Date Available"
}
